function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { text120, lineHeight } from "@churchofjesuschrist/eden-style-constants";
const Section = styled.section.withConfig({
  componentId: "sc-11f48jc-0"
})(["line-height:", ";color:", ";& a{", ";&:hover{", ";}}& > :first-child{margin-block-start:0;}& > :last-child{margin-block-end:0;}& > :first-child > :first-child{margin-block-start:0;}& > :last-child > :last-child{margin-block-end:0;}"], lineHeight, _ref => {
  let {
    theme
  } = _ref;
  return theme.textColor ? theme.textColor : text120;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.linkColor ? `color: ${theme.linkColor}` : "";
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.linkHoverColor ? `color: ${theme.linkHoverColor}; text-decoration-color: ${theme.linkHoverColor}` : "";
});

const Wrapper = _ref4 => {
  let {
    children,
    theme = {},
    ...props
  } = _ref4;
  return /*#__PURE__*/React.createElement(Section, _extends({
    theme: theme
  }, props), children);
};

Wrapper.propTypes = {
  /* HTML/text content */
  children: PropTypes.node.isRequired,

  /* Theme colors to change */
  theme: PropTypes.shape({
    textColor: PropTypes.string,
    linkColor: PropTypes.string,
    linkHoverColor: PropTypes.string
  })
};
export default Wrapper;